import { Box, Flex } from 'reflexbox';
import styled from 'styled-components'
import { media } from "../../styled/themeVariables";
import {Button} from "../../forms/styled/form";
import {rem} from "polished";

export const FeaturedWrap = styled(Flex)`

`

export const FeaturedBuyBtn = styled(Button)<{ className: string }>`
  display: block;
  width: 100%;
  border-radius: 0;
  z-index: 10;
  background-color: transparent;
  color: ${(props) => props.className === 'sold' || props.className === 'private' || props.className === 'reserved' ? props.theme.colors.soldColor : props.theme.colors.ctaColor};
  font-weight: bold;
  padding: ${rem(10)} ${rem(45)};
  font-size: ${rem(15)};
  cursor: ${(props) => props.className === 'sold' || props.className === 'private' || props.className === 'reserved' ? 'default' : 'pointer'};
  margin-bottom: ${rem(15)};

  &:hover {
    background-color: transparent;
    color: ${(props) => props.className === 'sold' || props.className === 'private' || props.className === 'reserved' ? props.theme.colors.soldColor : props.theme.colors.ctaHover};
  }

  &:hover svg {
    fill: ${(props) => props.theme.colors.text};
  }

  ${media.tablet`
    padding: ${rem(16)} ${rem(45)};
 `}
`;

export const FeaturedBox = styled(Box)`
  height: 300px;
  overflow: hidden;
  position: relative;
  display: flex;
  cursor: pointer;

  &:hover ${FeaturedBuyBtn} {
    display: block;
  }

  > img {
    width: 100%;
  }

  ${media.tablet`
    height: 340px;
    border: 1px solid ${(props) => props.theme.colors.gold};
  `}

  ${media.desktop`
    height: 450px;
  `}
`

export const FeaturedThumbnails = styled(Box)`

`

export const ImgDesc = styled.div`
   margin-top: -10px;

  p {
    font-size: 14px;
    line-height: 1.5;
  }
`

export const Thumb = styled.div`
  box-sizing: border-box;
  height: 100px;
  float: left;
  width: 31%;
  margin: 0 5px 10px;
  border: 1px solid ${(props) => props.theme.colors.gold};
  overflow: hidden;

  img {
    max-width: 100%;
  }

  ${media.tablet`
    height: 113px;
 `}

  ${media.desktop`
    height: 143px;
 `}
`
